export default __webpack_public_path__ + "static/what-we-do-a39ea96e317fd9a194929f370aaf5958.svg";